"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTextareaStyles = void 0;
const core_1 = require("@material-ui/core");
exports.useTextareaStyles = core_1.makeStyles((theme) => ({
    root: {
        backgroundColor: '#D8F4F7',
        width: '100%',
        border: 'none',
        resize: 'vertical',
        padding: '8px',
        '&:focus': {
            outline: `${theme.palette.primary.main} auto 1px`,
        },
    },
}));
//# sourceMappingURL=textarea.style.js.map